import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import {selectIsLoggedIn, useAuth, useAuthStore} from '@nike/aegis-auth-react'
import DataEntryPage from './components/DataEntryPage/DataEntryPage';
import LandingPage from './components/LandingPage/LandingPage';
import Spinner from "./components/Spinner/Spinner";
import aegisClient from "./auth/client";

const App = () => {
  const { loginComplete} = useAuth(aegisClient)
  const isLoggedIn  = useAuthStore(selectIsLoggedIn)

  if (!loginComplete) return <Spinner />
  if (!isLoggedIn) return <LandingPage />

  return (
    <Router>
      <Routes>
          <Route path="/" element={<DataEntryPage />} />
          <Route path="/logout" element={<LandingPage />} />
      </Routes>
    </Router>
  );
};

export default App;
